export default __webpack_public_path__ + "cff0f17844d255e4d4673335633237db.svg";